export default {
  selectedYear: '',
  selectedSeason: '',
  entiretyGraphOptions: {
    chartArea: {
      width: 500,
      height: 250,
      top: 10,
      left: 30
    },
    backgroundColor: 'none',
    height: 300,
    slices: {
      0: { color: '#0f6594' },
      1: { color: '#e86161' }
    },
    pieSliceText: 'none',
    tooltip: {
      trigger: 'none'
    },
    axitsTitle: {
      position: 'none'
    },
    legend: {
      position: 'labeled',
      textStyle: { fontSize: 16, bold: true, color: '#888' }
    }
  },
  lossGraphOptions: {
    chartArea: {
      width: 500,
      height: 250,
      top: 10,
      left: 30
    },
    backgroundColor: 'none',
    height: 300,
    slices: {
      0: { color: '#de2424' },
      1: { color: '#de3030' },
      2: { color: '#e25050' },
      3: { color: '#e65656' },
      4: { color: '#e86161' },
      5: { color: '#eb7878' },
      6: { color: '#ee9090' },
      7: { color: '#f2a8a8' },
      8: { color: '#f5bfbf' },
      9: { color: '#fbe6e6' }
    },
    pieSliceText: 'none',
    tooltip: {
      trigger: 'none'
    },
    axitsTitle: {
      position: 'none'
    },
    titleTextStyle: { color: '#000', bold: true, fontSize: 22 },
    legend: {
      position: 'labeled',
      textStyle: { fontSize: 12, bold: true, color: '#888' }
    }
  }
}
